import styled from '@emotion/styled';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';
import { Colors } from 'styles/variables/colors';

type BurgerMenuProps = {
    isActive: boolean;
};

export const BurgerMenu = styled.button<BurgerMenuProps>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: 'Montserrat', sans-serif;
    font-size: 15px;
    color: ${Colors.darkGray};
    line-height: 18px;
    padding: 9px 12px;
    box-sizing: border-box;
    border: 2px solid ${Colors.orange};
    border-radius: 4px;
    fill: ${Colors.darkGray};
    transition: all 110ms ease;

    :hover {
        background-color: #f8f8f8;
    }
`;

export const DropDownMenu = styled.ul`
    border: 2px solid ${Colors.inputBorder};
    border-radius: 4px;
`;

export const BurgerIcon = styled(ArrowDownIcon)`
    fill: inherit;
    width: 10px;
    margin-left: 14px;
`;
